[
  {
    "type": "people",
    "title": "人物",
    "info": [
      {
        "emoji": "😃",
        "name": "smiling face with open mouth",
        "code": "U+1F603"
      },
      {
        "emoji": "😄",
        "name": "smiling face with open mouth and smiling eyes",
        "code": "U+1F604"
      },
      {
        "emoji": "😁",
        "name": "grinning face with smiling eyes",
        "code": "U+1F601"
      },
      {
        "emoji": "😆",
        "name": "smiling face with open mouth and tightly-closed eyes",
        "code": "U+1F606"
      },
      {
        "emoji": "😅",
        "name": "smiling face with open mouth and cold sweat",
        "code": "U+1F605"
      },
      {
        "emoji": "😂",
        "name": "face with tears of joy",
        "code": "U+1F602"
      },
      {
        "emoji": "😊",
        "name": "smiling face with smiling eyes",
        "code": "U+1F60A"
      },
      {
        "emoji": "😇",
        "name": "smiling face with halo",
        "code": "U+1F607"
      },
      {
        "emoji": "😉",
        "name": "winking face",
        "code": "U+1F609"
      },
      {
        "emoji": "😌",
        "name": "relieved face",
        "code": "U+1F60C"
      },
      {
        "emoji": "😍",
        "name": "smiling face with heart-shaped eyes",
        "code": "U+1F60D"
      },
      {
        "emoji": "😘",
        "name": "face throwing a kiss",
        "code": "U+1F618"
      },
      {
        "emoji": "😗",
        "name": "kissing face",
        "code": "U+1F617"
      },
      {
        "emoji": "😚",
        "name": "kissing face with closed eyes",
        "code": "U+1F61A"
      },
      {
        "emoji": "😙",
        "name": "kissing face with smiling eyes",
        "code": "U+1F619"
      },
      {
        "emoji": "😋",
        "name": "face savouring delicious food",
        "code": "U+1F60B"
      },
      {
        "emoji": "😛",
        "name": "face with stuck-out tongue",
        "code": "U+1F61B"
      },
      {
        "emoji": "😝",
        "name": "face with stuck-out tongue and tightly-closed eyes",
        "code": "U+1F61D"
      },
      {
        "emoji": "😜",
        "name": "face with stuck-out tongue and winking eye",
        "code": "U+1F61C"
      },
      {
        "emoji": "😏",
        "name": "smirking face",
        "code": "U+1F60F"
      },
      {
        "emoji": "😒",
        "name": "unamused face",
        "code": "U+1F612"
      },
      {
        "emoji": "😞",
        "name": "disappointed face",
        "code": "U+1F61E"
      },
      {
        "emoji": "😔",
        "name": "pensive face",
        "code": "U+1F614"
      },
      {
        "emoji": "😕",
        "name": "confused face",
        "code": "U+1F615"
      },
      {
        "emoji": "😟",
        "name": "worried face",
        "code": "U+1F61F"
      },
      {
        "emoji": "😣",
        "name": "persevering face",
        "code": "U+1F623"
      },
      {
        "emoji": "😖",
        "name": "confounded face",
        "code": "U+1F616"
      },
      {
        "emoji": "😫",
        "name": "tired face",
        "code": "U+1F62B"
      },
      {
        "emoji": "😩",
        "name": "weary face",
        "code": "U+1F629"
      },
      {
        "emoji": "😢",
        "name": "crying face",
        "code": "U+1F622"
      },
      {
        "emoji": "😭",
        "name": "loudly crying face",
        "code": "U+1F62D"
      },
      {
        "emoji": "😤",
        "name": "face with look of triumph",
        "code": "U+1F624"
      },
      {
        "emoji": "😠",
        "name": "angry face",
        "code": "U+1F620"
      },
      {
        "emoji": "😡",
        "name": "pouting face",
        "code": "U+1F621"
      },
      {
        "emoji": "😳",
        "name": "flushed face",
        "code": "U+1F633"
      },
      {
        "emoji": "😱",
        "name": "face screaming in fear",
        "code": "U+1F631"
      },
      {
        "emoji": "😨",
        "name": "fearful face",
        "code": "U+1F628"
      },
      {
        "emoji": "😰",
        "name": "face with open mouth and cold sweat",
        "code": "U+1F630"
      },
      {
        "emoji": "😥",
        "name": "disappointed but relieved face",
        "code": "U+1F625"
      },
      {
        "emoji": "😓",
        "name": "face with cold sweat",
        "code": "U+1F613"
      },
      {
        "emoji": "😶",
        "name": "face without mouth",
        "code": "U+1F636"
      },
      {
        "emoji": "😐",
        "name": "neutral face",
        "code": "U+1F610"
      },
      {
        "emoji": "😑",
        "name": "expressionless face",
        "code": "U+1F611"
      },
      {
        "emoji": "😬",
        "name": "grimacing face",
        "code": "U+1F62C"
      },
      {
        "emoji": "😦",
        "name": "frowning face with open mouth",
        "code": "U+1F626"
      },
      {
        "emoji": "😧",
        "name": "anguished face",
        "code": "U+1F627"
      },
      {
        "emoji": "😮",
        "name": "face with open mouth",
        "code": "U+1F62E"
      },
      {
        "emoji": "😯",
        "name": "hushed face",
        "code": "U+1F62F"
      },
      {
        "emoji": "😴",
        "name": "sleeping face",
        "code": "U+1F634"
      },
      {
        "emoji": "😪",
        "name": "sleepy face",
        "code": "U+1F62A"
      },
      {
        "emoji": "😵",
        "name": "dizzy face",
        "code": "U+1F635"
      },
      {
        "emoji": "😷",
        "name": "face with medical mask",
        "code": "U+1F637"
      },
      {
        "emoji": "😈",
        "name": "smiling face with horns",
        "code": "U+1F608"
      },
      {
        "emoji": "🙏",
        "name": "person with folded hands",
        "code": "U+1F64F"
      },
      {
        "emoji": "👀",
        "name": "eyes",
        "code": "U+1F440"
      },
      {
        "emoji": "👂",
        "name": "ear",
        "code": "U+1F442"
      },
      {
        "emoji": "👃",
        "name": "nose",
        "code": "U+1F443"
      },
      {
        "emoji": "👄",
        "name": "mouth",
        "code": "U+1F444"
      },
      {
        "emoji": "👅",
        "name": "tongue",
        "code": "U+1F445"
      },
      {
        "emoji": "💅",
        "name": "nail polish",
        "code": "U+1F485"
      },
      {
        "emoji": "💆",
        "name": "face massage",
        "code": "U+1F486"
      },
      {
        "emoji": "💇",
        "name": "haircut",
        "code": "U+1F487"
      },
      {
        "emoji": "👦",
        "name": "boy",
        "code": "U+1F466"
      },
      {
        "emoji": "👧",
        "name": "girl",
        "code": "U+1F467"
      },
      {
        "emoji": "👨",
        "name": "man",
        "code": "U+1F468"
      },
      {
        "emoji": "👩",
        "name": "woman",
        "code": "U+1F469"
      },
      {
        "emoji": "👪",
        "name": "family",
        "code": "U+1F46A"
      },
      {
        "emoji": "👬",
        "name": "man and man holding hands",
        "code": "U+1F46C"
      },
      {
        "emoji": "👭",
        "name": "woman and woman holding hands",
        "code": "U+1F46D"
      },
      {
        "emoji": "👮",
        "name": "police officer",
        "code": "U+1F46E"
      },
      {
        "emoji": "👯",
        "name": "woman with bunny ears",
        "code": "U+1F46F"
      },
      {
        "emoji": "👰",
        "name": "bride with veil",
        "code": "U+1F470"
      },
      {
        "emoji": "👱",
        "name": "person with blond hair",
        "code": "U+1F471"
      },
      {
        "emoji": "👲",
        "name": "man with gua pi mao",
        "code": "U+1F472"
      },
      {
        "emoji": "👳",
        "name": "man with turban",
        "code": "U+1F473"
      },
      {
        "emoji": "👴",
        "name": "older man",
        "code": "U+1F474"
      },
      {
        "emoji": "👵",
        "name": "older woman",
        "code": "U+1F475"
      },
      {
        "emoji": "👶",
        "name": "baby",
        "code": "U+1F476"
      },
      {
        "emoji": "👸",
        "name": "princess",
        "code": "U+1F478"
      },
      {
        "emoji": "👼",
        "name": "baby angel",
        "code": "U+1F47C"
      },
      {
        "emoji": "💁",
        "name": "information desk person",
        "code": "U+1F481"
      },
      {
        "emoji": "💂",
        "name": "guardsman",
        "code": "U+1F482"
      },
      {
        "emoji": "💃",
        "name": "dancer",
        "code": "U+1F483"
      },
      {
        "emoji": "🙅",
        "name": "face with no good gesture",
        "code": "U+1F645"
      },
      {
        "emoji": "🙆",
        "name": "face with ok gesture",
        "code": "U+1F646"
      },
      {
        "emoji": "🙇",
        "name": "person bowing deeply",
        "code": "U+1F647"
      },
      {
        "emoji": "🙋",
        "name": "happy person raising one hand",
        "code": "U+1F64B"
      },
      {
        "emoji": "🙍",
        "name": "person frowning",
        "code": "U+1F64D"
      },
      {
        "emoji": "🙎",
        "name": "person with pouting face",
        "code": "U+1F64E"
      },
      {
        "emoji": "🎅",
        "name": "father christmas",
        "code": "U+1F385"
      },
      {
        "emoji": "💏",
        "name": "kiss",
        "code": "U+1F48F"
      },
      {
        "emoji": "💑",
        "name": "couple with heart",
        "code": "U+1F491"
      },
      {
        "emoji": "💪",
        "name": "flexed biceps",
        "code": "U+1F4AA"
      },
      {
        "emoji": "✊",
        "name": "raised fist",
        "code": "U+270A"
      },
      {
        "emoji": "✋",
        "name": "raised hand",
        "code": "U+270B"
      },
      {
        "emoji": "👊",
        "name": "fisted hand sign",
        "code": "U+1F44A"
      },
      {
        "emoji": "👍",
        "name": "thumbs up sign",
        "code": "U+1F44D"
      },
      {
        "emoji": "👆",
        "name": "white up pointing backhand index",
        "code": "U+1F446"
      },
      {
        "emoji": "👇",
        "name": "white down pointing backhand index",
        "code": "U+1F447"
      },
      {
        "emoji": "👈",
        "name": "white left pointing backhand index",
        "code": "U+1F448"
      },
      {
        "emoji": "👉",
        "name": "white right pointing backhand index",
        "code": "U+1F449"
      },
      {
        "emoji": "👋",
        "name": "waving hand sign",
        "code": "U+1F44B"
      },
      {
        "emoji": "👏",
        "name": "clapping hands sign",
        "code": "U+1F44F"
      },
      {
        "emoji": "👌",
        "name": "ok hand sign",
        "code": "U+1F44C"
      },
      {
        "emoji": "👎",
        "name": "thumbs down sign",
        "code": "U+1F44E"
      },
      {
        "emoji": "👐",
        "name": "open hands sign",
        "code": "U+1F450"
      },
      {
        "emoji": "🙌",
        "name": "person raising both hands in celebration",
        "code": "U+1F64C"
      },
      {
        "emoji": "👤",
        "name": "bust in silhouette",
        "code": "U+1F464"
      },
      {
        "emoji": "👥",
        "name": "busts in silhouette",
        "code": "U+1F465"
      }
    ]
  },
  {
    "type": "article",
    "title": "物品",
    "info": [
      {
        "emoji": "📖",
        "name": "open book",
        "code": "U+1F4D6"
      },
      {
        "emoji": "📔",
        "name": "notebook with decorative cover",
        "code": "U+1F4D4"
      },
      {
        "emoji": "📕",
        "name": "closed book",
        "code": "U+1F4D5"
      },
      {
        "emoji": "📗",
        "name": "green book",
        "code": "U+1F4D7"
      },
      {
        "emoji": "📘",
        "name": "blue book",
        "code": "U+1F4D8"
      },
      {
        "emoji": "📙",
        "name": "orange book",
        "code": "U+1F4D9"
      },
      {
        "emoji": "📚",
        "name": "books",
        "code": "U+1F4DA"
      },
      {
        "emoji": "📒",
        "name": "ledger",
        "code": "U+1F4D2"
      },
      {
        "emoji": "📁",
        "name": "file folder",
        "code": "U+1F4C1"
      },
      {
        "emoji": "📂",
        "name": "open file folder",
        "code": "U+1F4C2"
      },
      {
        "emoji": "📓",
        "name": "notebook",
        "code": "U+1F4D3"
      },
      {
        "emoji": "📅",
        "name": "calendar",
        "code": "U+1F4C5"
      },
      {
        "emoji": "📌",
        "name": "pushpin",
        "code": "U+1F4CC"
      },
      {
        "emoji": "📍",
        "name": "round pushpin",
        "code": "U+1F4CD"
      },
      {
        "emoji": "⏰",
        "name": "alarm clock",
        "code": "U+23F0"
      },
      {
        "emoji": "📜",
        "name": "scroll",
        "code": "U+1F4DC"
      },
      {
        "emoji": "📋",
        "name": "clipboard",
        "code": "U+1F4CB"
      },
      {
        "emoji": "📃",
        "name": "page with curl",
        "code": "U+1F4C3"
      },
      {
        "emoji": "📄",
        "name": "page facing up",
        "code": "U+1F4C4"
      },
      {
        "emoji": "🔖",
        "name": "bookmark",
        "code": "U+1F516"
      },
      {
        "emoji": "📊",
        "name": "bar chart",
        "code": "U+1F4CA"
      },
      {
        "emoji": "📈",
        "name": "chart with upwards trend",
        "code": "U+1F4C8"
      },
      {
        "emoji": "📉",
        "name": "chart with downwards trend",
        "code": "U+1F4C9"
      },
      {
        "emoji": "📝",
        "name": "memo",
        "code": "U+1F4DD"
      },
      {
        "emoji": "📑",
        "name": "bookmark tabs",
        "code": "U+1F4D1"
      },
      {
        "emoji": "📠",
        "name": "fax machine",
        "code": "U+1F4E0"
      },
      {
        "emoji": "📨",
        "name": "incoming envelope",
        "code": "U+1F4E8"
      },
      {
        "emoji": "📩",
        "name": "envelope with downwards arrow above",
        "code": "U+1F4E9"
      },
      {
        "emoji": "📪",
        "name": "closed mailbox with lowered flag",
        "code": "U+1F4EA"
      },
      {
        "emoji": "📫",
        "name": "closed mailbox with raised flag",
        "code": "U+1F4EB"
      },
      {
        "emoji": "📮",
        "name": "postbox",
        "code": "U+1F4EE"
      },
      {
        "emoji": "📰",
        "name": "newspaper",
        "code": "U+1F4F0"
      },
      {
        "emoji": "📢",
        "name": "public address loudspeaker",
        "code": "U+1F4E2"
      },
      {
        "emoji": "📣",
        "name": "cheering megaphone",
        "code": "U+1F4E3"
      },
      {
        "emoji": "📡",
        "name": "satellite antenna",
        "code": "U+1F4E1"
      },
      {
        "emoji": "📤",
        "name": "outbox tray",
        "code": "U+1F4E4"
      },
      {
        "emoji": "📥",
        "name": "inbox tray",
        "code": "U+1F4E5"
      },
      {
        "emoji": "📦",
        "name": "package",
        "code": "U+1F4E6"
      },
      {
        "emoji": "📧",
        "name": "e-mail symbol",
        "code": "U+1F4E7"
      },
      {
        "emoji": "💺",
        "name": "seat",
        "code": "U+1F4BA"
      },
      {
        "emoji": "💻",
        "name": "personal computer",
        "code": "U+1F4BB"
      },
      {
        "emoji": "📎",
        "name": "paperclip",
        "code": "U+1F4CE"
      },
      {
        "emoji": "💼",
        "name": "briefcase",
        "code": "U+1F4BC"
      },
      {
        "emoji": "💽",
        "name": "minidisc",
        "code": "U+1F4BD"
      },
      {
        "emoji": "💾",
        "name": "floppy disk",
        "code": "U+1F4BE"
      },
      {
        "emoji": "💿",
        "name": "optical disc",
        "code": "U+1F4BF"
      },
      {
        "emoji": "📀",
        "name": "dvd",
        "code": "U+1F4C0"
      },
      {
        "emoji": "🎓",
        "name": "graduation cap",
        "code": "U+1F393"
      },
      {
        "emoji": "🎒",
        "name": "school satchel",
        "code": "U+1F392"
      },
      {
        "emoji": "⌚",
        "name": "watch",
        "code": "U+231A"
      },
      {
        "emoji": "📇",
        "name": "card index",
        "code": "U+1F4C7"
      },
      {
        "emoji": "📞",
        "name": "telephone receiver",
        "code": "U+1F4DE"
      },
      {
        "emoji": "📱",
        "name": "mobile phone",
        "code": "U+1F4F1"
      },
      {
        "emoji": "📺",
        "name": "television",
        "code": "U+1F4FA"
      },
      {
        "emoji": "📻",
        "name": "radio",
        "code": "U+1F4FB"
      },
      {
        "emoji": "📼",
        "name": "videocassette",
        "code": "U+1F4FC"
      },
      {
        "emoji": "📟",
        "name": "pager",
        "code": "U+1F4DF"
      },
      {
        "emoji": "⌛",
        "name": "hourglass",
        "code": "U+231B"
      },
      {
        "emoji": "⏳",
        "name": "hourglass with flowing sand",
        "code": "U+23F3"
      },
      {
        "emoji": "💄",
        "name": "lipstick",
        "code": "U+1F484"
      },
      {
        "emoji": "💰",
        "name": "money bag",
        "code": "U+1F4B0"
      },
      {
        "emoji": "💹",
        "name": "chart with upwards trend and yen sign",
        "code": "U+1F4B9"
      },
      {
        "emoji": "💳",
        "name": "credit card",
        "code": "U+1F4B3"
      },
      {
        "emoji": "💴",
        "name": "banknote with yen sign",
        "code": "U+1F4B4"
      },
      {
        "emoji": "💵",
        "name": "banknote with dollar sign",
        "code": "U+1F4B5"
      },
      {
        "emoji": "💸",
        "name": "money with wings",
        "code": "U+1F4B8"
      },
      {
        "emoji": "🔥",
        "name": "fire",
        "code": "U+1F525"
      },
      {
        "emoji": "🔦",
        "name": "electric torch",
        "code": "U+1F526"
      },
      {
        "emoji": "🔧",
        "name": "wrench",
        "code": "U+1F527"
      },
      {
        "emoji": "🔨",
        "name": "hammer",
        "code": "U+1F528"
      },
      {
        "emoji": "🔪",
        "name": "hocho",
        "code": "U+1F52A"
      },
      {
        "emoji": "🔫",
        "name": "pistol",
        "code": "U+1F52B"
      },
      {
        "emoji": "🔮",
        "name": "crystal ball",
        "code": "U+1F52E"
      },
      {
        "emoji": "💉",
        "name": "syringe",
        "code": "U+1F489"
      },
      {
        "emoji": "💊",
        "name": "pill",
        "code": "U+1F48A"
      },
      {
        "emoji": "🎀",
        "name": "ribbon",
        "code": "U+1F380"
      },
      {
        "emoji": "👞",
        "name": "mans shoe",
        "code": "U+1F45E"
      },
      {
        "emoji": "👟",
        "name": "athletic shoe",
        "code": "U+1F45F"
      },
      {
        "emoji": "👠",
        "name": "high-heeled shoe",
        "code": "U+1F460"
      },
      {
        "emoji": "👡",
        "name": "womans sandal",
        "code": "U+1F461"
      },
      {
        "emoji": "👢",
        "name": "womans boots",
        "code": "U+1F462"
      },
      {
        "emoji": "👣",
        "name": "footprints",
        "code": "U+1F463"
      },
      {
        "emoji": "👓",
        "name": "eyeglasses",
        "code": "U+1F453"
      },
      {
        "emoji": "👕",
        "name": "t-shirt",
        "code": "U+1F455"
      },
      {
        "emoji": "👖",
        "name": "jeans",
        "code": "U+1F456"
      },
      {
        "emoji": "👑",
        "name": "crown",
        "code": "U+1F451"
      },
      {
        "emoji": "👔",
        "name": "necktie",
        "code": "U+1F454"
      },
      {
        "emoji": "👒",
        "name": "womans hat",
        "code": "U+1F452"
      },
      {
        "emoji": "👗",
        "name": "dress",
        "code": "U+1F457"
      },
      {
        "emoji": "👘",
        "name": "kimono",
        "code": "U+1F458"
      },
      {
        "emoji": "👙",
        "name": "bikini",
        "code": "U+1F459"
      },
      {
        "emoji": "👚",
        "name": "womans clothes",
        "code": "U+1F45A"
      },
      {
        "emoji": "👛",
        "name": "purse",
        "code": "U+1F45B"
      },
      {
        "emoji": "👜",
        "name": "handbag",
        "code": "U+1F45C"
      },
      {
        "emoji": "👝",
        "name": "pouch",
        "code": "U+1F45D"
      },
      {
        "emoji": "📏",
        "name": "straight ruler",
        "code": "U+1F4CF"
      },
      {
        "emoji": "📐",
        "name": "triangular ruler",
        "code": "U+1F4D0"
      },
      {
        "emoji": "🎽",
        "name": "running shirt with sash",
        "code": "U+1F3BD"
      },
      {
        "emoji": "🛀",
        "name": "bath",
        "code": "U+1F6C0"
      },
      {
        "emoji": "🛁",
        "name": "bathtub",
        "code": "U+1F6C1"
      },
      {
        "emoji": "🚰",
        "name": "potable water symbol",
        "code": "U+1F6B0"
      },
      {
        "emoji": "🚿",
        "name": "shower",
        "code": "U+1F6BF"
      },
      {
        "emoji": "🚽",
        "name": "toilet",
        "code": "U+1F6BD"
      },
      {
        "emoji": "🚪",
        "name": "door",
        "code": "U+1F6AA"
      },
      {
        "emoji": "🔊",
        "name": "speaker with three sound waves",
        "code": "U+1F50A"
      },
      {
        "emoji": "🔋",
        "name": "battery",
        "code": "U+1F50B"
      },
      {
        "emoji": "🔌",
        "name": "electric plug",
        "code": "U+1F50C"
      },
      {
        "emoji": "🔍",
        "name": "eft-pointing magnifying glass",
        "code": "U+1F50D"
      },
      {
        "emoji": "🔒",
        "name": "lock",
        "code": "U+1F512"
      },
      {
        "emoji": "🔐",
        "name": "closed lock with key",
        "code": "U+1F510"
      },
      {
        "emoji": "🔑",
        "name": "key",
        "code": "U+1F511"
      },
      {
        "emoji": "💡",
        "name": "electric light bulb",
        "code": "U+1F4A1"
      },
      {
        "emoji": "💣",
        "name": "bomb",
        "code": "U+1F4A3"
      },
      {
        "emoji": "💩",
        "name": "pile of poo",
        "code": "U+1F4A9"
      },
      {
        "emoji": "🔬",
        "name": "microscope",
        "code": "U+1F52C"
      },
      {
        "emoji": "🔭",
        "name": "telescope",
        "code": "U+1F52D"
      }
    ]
  },
  {
    "type": "symbol",
    "title": "其他符号",
    "info": [
      {
        "emoji": "🔰",
        "name": "japanese symbol for beginner",
        "code": "U+1F530"
      },
      {
        "emoji": "💢",
        "name": "anger symbol",
        "code": "U+1F4A2"
      },
      {
        "emoji": "💤",
        "name": "sleeping symbol",
        "code": "U+1F4A4"
      },
      {
        "emoji": "💥",
        "name": "collision symbol",
        "code": "U+1F4A5"
      },
      {
        "emoji": "💬",
        "name": "speech balloon",
        "code": "U+1F4AC"
      },
      {
        "emoji": "💯",
        "name": "hundred points symbol",
        "code": "U+1F4AF"
      },
      {
        "emoji": "🔴",
        "name": "large red circle",
        "code": "U+1F534"
      },
      {
        "emoji": "🔵",
        "name": "large blue circle",
        "code": "U+1F535"
      },
      {
        "emoji": "🔶",
        "name": "large orange diamond",
        "code": "U+1F536"
      },
      {
        "emoji": "🔷",
        "name": "large blue diamond",
        "code": "U+1F537"
      },
      {
        "emoji": "💭",
        "name": "thought balloon",
        "code": "U+1F4AD"
      },
      {
        "emoji": "🔄",
        "name": "anticlockwise downwards and upwards open circle arrows",
        "code": "U+1F504"
      },
      {
        "emoji": "🔀",
        "name": "twisted rightwards arrows",
        "code": "U+1F500"
      },
      {
        "emoji": "🔁",
        "name": "clockwise rightwards and leftwards open circle arrows",
        "code": "U+1F501"
      },
      {
        "emoji": "🔃",
        "name": "clockwise downwards and upwards open circle arrows",
        "code": "U+1F503"
      },
      {
        "emoji": "🔼",
        "name": "up-pointing small red triangle",
        "code": "U+1F53C"
      },
      {
        "emoji": "🔽",
        "name": "down-pointing small red triangle",
        "code": "U+1F53D"
      },
      {
        "emoji": "⏫",
        "name": "black up-pointing double triangle",
        "code": "U+23EB"
      },
      {
        "emoji": "⏬",
        "name": "black down-pointing double triangle",
        "code": "U+23EC"
      },
      {
        "emoji": "⏪",
        "name": "black left-pointing double triangle",
        "code": "U+23EA"
      },
      {
        "emoji": "⏩",
        "name": "black right-pointing double triangle",
        "code": "U+23E9"
      },
      {
        "emoji": "🔺",
        "name": "up-pointing red triangle",
        "code": "U+1F53A"
      },
      {
        "emoji": "🔻",
        "name": "down-pointing red triangle",
        "code": "U+1F53B"
      },
      {
        "emoji": "⭕",
        "name": "heavy large circle",
        "code": "U+2B55"
      },
      {
        "emoji": "❌",
        "name": "cross mark",
        "code": "U+274C"
      },
      {
        "emoji": "❗",
        "name": "heavy exclamation mark symbol",
        "code": "U+2757"
      },
      {
        "emoji": "❓",
        "name": "black question mark ornament",
        "code": "U+2753"
      },
      {
        "emoji": "❎",
        "name": "negative squared cross mark",
        "code": "U+274E"
      },
      {
        "emoji": "✅",
        "name": "white heavy check mark",
        "code": "U+2705"
      },
      {
        "emoji": "💖",
        "name": "sparkling heart",
        "code": "U+1F496"
      },
      {
        "emoji": "💓",
        "name": "beating heart",
        "code": "U+1F493"
      },
      {
        "emoji": "💗",
        "name": "growing heart",
        "code": "U+1F497"
      },
      {
        "emoji": "💕",
        "name": "two hearts",
        "code": "U+1F495"
      },
      {
        "emoji": "💘",
        "name": "heart with arrow",
        "code": "U+1F498"
      },
      {
        "emoji": "💔",
        "name": "broken heart",
        "code": "U+1F494"
      },
      {
        "emoji": "💙",
        "name": "blue heart",
        "code": "U+1F499"
      },
      {
        "emoji": "💚",
        "name": "green heart",
        "code": "U+1F49A"
      },
      {
        "emoji": "💛",
        "name": "yellow heart",
        "code": "U+1F49B"
      },
      {
        "emoji": "💜",
        "name": "purple heart",
        "code": "U+1F49C"
      },
      {
        "emoji": "💝",
        "name": "heart with ribbon",
        "code": "U+1F49D"
      },
      {
        "emoji": "💞",
        "name": "revolving hearts",
        "code": "U+1F49E"
      },
      {
        "emoji": "💟",
        "name": "heart decoration",
        "code": "U+1F49F"
      },
      {
        "emoji": "⛔",
        "name": "no entry",
        "code": "U+26D4"
      },
      {
        "emoji": "🚹",
        "name": "mens symbol",
        "code": "U+1F6B9"
      },
      {
        "emoji": "🚺",
        "name": "womens symbol",
        "code": "U+1F6BA"
      },
      {
        "emoji": "🚻",
        "name": "restroom",
        "code": "U+1F6BB"
      },
      {
        "emoji": "🚾",
        "name": "water closet",
        "code": "U+1F6BE"
      },
      {
        "emoji": "🚼",
        "name": "baby symbol",
        "code": "U+1F6BC"
      },
      {
        "emoji": "🚫",
        "name": "no entry sign",
        "code": "U+1F6AB"
      },
      {
        "emoji": "📵",
        "name": "no mobile phones",
        "code": "U+1F4F5"
      },
      {
        "emoji": "🔯",
        "name": "six pointed star with middle dot",
        "code": "U+1F52F"
      },
      {
        "emoji": "🔠",
        "name": "input symbol for latin capital letters",
        "code": "U+1F520"
      },
      {
        "emoji": "🔡",
        "name": "input symbol for latin small letters",
        "code": "U+1F521"
      },
      {
        "emoji": "🔢",
        "name": "input symbol for numbers",
        "code": "U+1F522"
      },
      {
        "emoji": "🔣",
        "name": "input symbol for symbols",
        "code": "U+1F523"
      },
      {
        "emoji": "🔤",
        "name": "input symbol for latin letters",
        "code": "U+1F524"
      },
      {
        "emoji": "📶",
        "name": "antenna with bars",
        "code": "U+1F4F6"
      },
      {
        "emoji": "🚮",
        "name": "put litter in its place symbol",
        "code": "U+1F6AE"
      },
      {
        "emoji": "🕐",
        "name": "clock face one oclock",
        "code": "U+1F550"
      },
      {
        "emoji": "🕑",
        "name": "clock face two oclock",
        "code": "U+1F551"
      },
      {
        "emoji": "🕒",
        "name": "clock face three oclock",
        "code": "U+1F552"
      },
      {
        "emoji": "🕓",
        "name": "clock face four oclock",
        "code": "U+1F553"
      },
      {
        "emoji": "🕔",
        "name": "clock face five oclock",
        "code": "U+1F554"
      },
      {
        "emoji": "🕕",
        "name": "clock face six oclock",
        "code": "U+1F555"
      },
      {
        "emoji": "🕖",
        "name": "clock face seven oclock",
        "code": "U+1F556"
      },
      {
        "emoji": "🕗",
        "name": "clock face eight oclock",
        "code": "U+1F557"
      },
      {
        "emoji": "🕘",
        "name": "clock face nine oclock",
        "code": "U+1F558"
      },
      {
        "emoji": "🕙",
        "name": "clock face ten oclock",
        "code": "U+1F559"
      },
      {
        "emoji": "🕚",
        "name": "clock face eleven oclock",
        "code": "U+1F55A"
      },
      {
        "emoji": "🕛",
        "name": "clock face twelve oclock",
        "code": "U+1F55B"
      },
      {
        "emoji": "0️⃣",
        "name": "keycap digit zero",
        "code": "U+0030"
      },
      {
        "emoji": "1️⃣",
        "name": "keycap digit one",
        "code": "U+0031"
      },
      {
        "emoji": "2️⃣",
        "name": "keycap digit two",
        "code": "U+0032"
      },
      {
        "emoji": "3️⃣",
        "name": "keycap digit three",
        "code": "U+0033"
      },
      {
        "emoji": "4️⃣",
        "name": "keycap digit four",
        "code": "U+0034"
      },
      {
        "emoji": "5️⃣",
        "name": "keycap digit five",
        "code": "U+0035"
      },
      {
        "emoji": "6️⃣",
        "name": "keycap digit six",
        "code": "U+0036"
      },
      {
        "emoji": "7️⃣",
        "name": "keycap digit seven",
        "code": "U+0037"
      },
      {
        "emoji": "8️⃣",
        "name": "keycap digit eight",
        "code": "U+0038"
      },
      {
        "emoji": "9️⃣",
        "name": "keycap digit nine",
        "code": "U+0039"
      },
      {
        "emoji": "🔟",
        "name": "keycap ten",
        "code": "U+1F51F"
      },
      {
        "emoji": "⬆",
        "name": "up arrow",
        "code": "U+2B06"
      },
      {
        "emoji": "↗",
        "name": "up-right arrow",
        "code": "U+2197"
      },
      {
        "emoji": "➡",
        "name": "right arrow",
        "code": "U+27A1"
      },
      {
        "emoji": "↘",
        "name": "down-right arrow",
        "code": "U+2198"
      },
      {
        "emoji": "⬇",
        "name": "down arrow",
        "code": "U+2B07"
      },
      {
        "emoji": "↙",
        "name": "down-left arrow",
        "code": "U+2199"
      },
      {
        "emoji": "⬅",
        "name": "left arrow",
        "code": "U+2B05"
      },
      {
        "emoji": "↖",
        "name": "up-left arrow",
        "code": "U+2196"
      },
      {
        "emoji": "↕",
        "name": "up-down arrow",
        "code": "U+2195"
      },
      {
        "emoji": "↔",
        "name": "left-right arrow",
        "code": "U+2194"
      },
      {
        "emoji": "↩",
        "name": "right arrow curving left",
        "code": "U+21A9"
      },
      {
        "emoji": "↪",
        "name": "left arrow curving right",
        "code": "U+21AA"
      },
      {
        "emoji": "⤴",
        "name": "right arrow curving up",
        "code": "U+2934"
      },
      {
        "emoji": "⤵",
        "name": "right arrow curving down",
        "code": "U+2935"
      },
      {
        "emoji": "🔙",
        "name": "BACK arrow",
        "code": "U+1F519"
      },
      {
        "emoji": "🔚",
        "name": "END arrow",
        "code": "U+1F51A"
      },
      {
        "emoji": "🔛",
        "name": "ON! arrow",
        "code": "U+1F51B"
      },
      {
        "emoji": "🔜",
        "name": "SOON arrow",
        "code": "U+1F51C"
      },
      {
        "emoji": "🔝",
        "name": "TOP arrow",
        "code": "U+1F51D\t"
      }
    ]
  },
  {
    "type": "culture",
    "title": "文化",
    "info": [
      {
        "emoji": "💎",
        "name": "gem stone",
        "code": "U+1F48E"
      },
      {
        "emoji": "💠",
        "name": "diamond shape with a dot inside",
        "code": "U+1F4A0"
      },
      {
        "emoji": "💍",
        "name": "ring",
        "code": "U+1F48D"
      },
      {
        "emoji": "💋",
        "name": "kiss mark",
        "code": "U+1F48B"
      },
      {
        "emoji": "💌",
        "name": "love letter",
        "code": "U+1F48C"
      },
      {
        "emoji": "🔞",
        "name": "no one under eighteen symbol",
        "code": "U+1F51E"
      },
      {
        "emoji": "👹",
        "name": "japanese ogre",
        "code": "U+1F479"
      },
      {
        "emoji": "👺",
        "name": "japanese goblin",
        "code": "U+1F47"
      },
      {
        "emoji": "👻",
        "name": "ghost",
        "code": "U+1F47B"
      },
      {
        "emoji": "👽",
        "name": "extraterrestrial alien",
        "code": "U+1F47D"
      },
      {
        "emoji": "👾",
        "name": "alien monster",
        "code": "U+1F47E"
      },
      {
        "emoji": "👿",
        "name": "imp",
        "code": "U+1F47F"
      },
      {
        "emoji": "💀",
        "name": "skull",
        "code": "U+1F480"
      },
      {
        "emoji": "🏮",
        "name": "izakaya lantern",
        "code": "U+1F3EE"
      },
      {
        "emoji": "🗻",
        "name": "mount fuji",
        "code": "U+1F5FB"
      },
      {
        "emoji": "🗼",
        "name": "tokyo tower",
        "code": "U+1F5FC"
      },
      {
        "emoji": "🔱",
        "name": "trident emblem",
        "code": "U+1F531"
      },
      {
        "emoji": "🎌",
        "name": "crossed flags",
        "code": "U+1F38C"
      },
      {
        "emoji": "🎎",
        "name": "japanese dolls",
        "code": "U+1F38E"
      },
      {
        "emoji": "🎏",
        "name": "carp streamer",
        "code": "U+1F38F"
      },
      {
        "emoji": "🚩",
        "name": "triangular flag on post",
        "code": "U+1F6A9"
      },
      {
        "emoji": "🎑",
        "name": "moon viewing ceremony",
        "code": "U+1F391"
      }
    ]
  },
  {
    "type": "nature",
    "title": "自然",
    "info": [
      {
        "emoji": "🌏",
        "name": "earth globe asia-australia",
        "code": "U+1F30F"
      },
      {
        "emoji": "🌎",
        "name": "earth globe americas",
        "code": "U+1F30E"
      },
      {
        "emoji": "🌍",
        "name": "earth globe europe-africa",
        "code": "U+1F30D"
      },
      {
        "emoji": "🌞",
        "name": "sun with face",
        "code": "U+1F31e"
      },
      {
        "emoji": "🌝",
        "name": "full moon with face",
        "code": "U+1F31D"
      },
      {
        "emoji": "🌚",
        "name": "new moon with face",
        "code": "U+1F31A"
      },
      {
        "emoji": "🌘",
        "name": "waning crescent moon symbol",
        "code": "U+1F318"
      },
      {
        "emoji": "🌗",
        "name": "last quarter moon symbol",
        "code": "U+1F317"
      },
      {
        "emoji": "🌖",
        "name": "waning gibbous moon symbol",
        "code": "U+1F316"
      },
      {
        "emoji": "🌕",
        "name": "full moon symbol",
        "code": "U+1F315"
      },
      {
        "emoji": "🌔",
        "name": "waxing gibbous moon symbol",
        "code": "U+1F314"
      },
      {
        "emoji": "🌓",
        "name": "first quarter moon symbol",
        "code": "U+1F313"
      },
      {
        "emoji": "🌒",
        "name": "waxing crescent moon symbol",
        "code": "U+1F312"
      },
      {
        "emoji": "🌑",
        "name": "new moon symbol",
        "code": "U+1F311"
      },
      {
        "emoji": "🌜",
        "name": "last quarter moon with face",
        "code": "U+1F31C"
      },
      {
        "emoji": "🌛",
        "name": "first quarter moon with face",
        "code": "U+1F31B"
      },
      {
        "emoji": "🌙",
        "name": "crescent moon",
        "code": "U+1F319"
      },
      {
        "emoji": "⭐",
        "name": "white medium star",
        "code": "U+2B50"
      },
      {
        "emoji": "🌟",
        "name": "glowing star",
        "code": "U+1F31F"
      },
      {
        "emoji": "💫",
        "name": "dizzy symbol",
        "code": "U+1F4AB"
      },
      {
        "emoji": "✨",
        "name": "sparkles",
        "code": "U+2728"
      },
      {
        "emoji": "🌲",
        "name": "evergreen tree",
        "code": "U+1F332"
      },
      {
        "emoji": "🌳",
        "name": "deciduous tree",
        "code": "U+1F333"
      },
      {
        "emoji": "⛄",
        "name": "snowman without snow",
        "code": "U+26C4"
      },
      {
        "emoji": "🌀",
        "name": "cyclone",
        "code": "U+1F300"
      },
      {
        "emoji": "🌂",
        "name": "closed umbrella",
        "code": "U+1F302"
      },
      {
        "emoji": "🌈",
        "name": "rainbow",
        "code": "U+1F308"
      },
      {
        "emoji": "💦",
        "name": "splashing sweat symbol",
        "code": "U+1F4A6"
      },
      {
        "emoji": "💨",
        "name": "dash symbol",
        "code": "U+1F4A8"
      },
      {
        "emoji": "⛅",
        "name": "sun behind cloud",
        "code": "U+26C5"
      },
      {
        "emoji": "🌊",
        "name": "water wave",
        "code": "U+1F30A"
      },
      {
        "emoji": "🌋",
        "name": "volcano",
        "code": "U+1F30B"
      },
      {
        "emoji": "🌁",
        "name": "foggy",
        "code": "U+1F301"
      },
      {
        "emoji": "🌃",
        "name": "night with stars",
        "code": "U+1F303"
      },
      {
        "emoji": "🌄",
        "name": "sunrise over mountains",
        "code": "U+1F304"
      },
      {
        "emoji": "🌅",
        "name": "sunrise",
        "code": "U+1F305"
      },
      {
        "emoji": "🌆",
        "name": "cityscape at dusk",
        "code": "U+1F306"
      },
      {
        "emoji": "🌇",
        "name": "sunset over buildings",
        "code": "U+1F307"
      },
      {
        "emoji": "🌉",
        "name": "bridge at night",
        "code": "U+1F309"
      },
      {
        "emoji": "🌌",
        "name": "milky way",
        "code": "U+1F30C"
      },
      {
        "emoji": "🌠",
        "name": "shooting star",
        "code": "U+1F320"
      },
      {
        "emoji": "🗾",
        "name": "silhouette of japan",
        "code": "U+1F5FE"
      },
      {
        "emoji": "🍀",
        "name": "four leaf clover",
        "code": "U+1F340"
      },
      {
        "emoji": "🌷",
        "name": "tulip",
        "code": "U+1F337"
      },
      {
        "emoji": "🌱",
        "name": "seedling",
        "code": "U+1F331"
      },
      {
        "emoji": "🍁",
        "name": "maple leaf",
        "code": "U+1F341"
      },
      {
        "emoji": "🌸",
        "name": "cherry blossom",
        "code": "U+1F338"
      },
      {
        "emoji": "🍂",
        "name": "fallen leaf",
        "code": "U+1F342"
      },
      {
        "emoji": "🍃",
        "name": "leaf fluttering in wind",
        "code": "U+1F343"
      },
      {
        "emoji": "🌺",
        "name": "hibiscus",
        "code": "U+1F33A"
      },
      {
        "emoji": "🌻",
        "name": "sunflower",
        "code": "U+1F33B"
      },
      {
        "emoji": "🌴",
        "name": "palm tree",
        "code": "U+1F334"
      },
      {
        "emoji": "🌵",
        "name": "cactus",
        "code": "U+1F335"
      },
      {
        "emoji": "🌾",
        "name": "ear of rice",
        "code": "U+1F33E"
      },
      {
        "emoji": "🌼",
        "name": "blossom",
        "code": "U+1F33C"
      },
      {
        "emoji": "🌿",
        "name": "herb",
        "code": "U+1F33F"
      },
      {
        "emoji": "💐",
        "name": "bouquet",
        "code": "U+1F490"
      }
    ]
  },
  {
    "type": "recreation",
    "title": "娱乐活动",
    "info": [
      {
        "emoji": "⚾",
        "name": "baseball",
        "code": "U+26BE"
      },
      {
        "emoji": "🎾",
        "name": "tennis racquet and ball",
        "code": "U+1F3BE"
      },
      {
        "emoji": "⚽",
        "name": "soccer ball",
        "code": "U+26BD"
      },
      {
        "emoji": "🏀",
        "name": "basketball and hoop",
        "code": "U+1F3C0"
      },
      {
        "emoji": "🏈",
        "name": "american football",
        "code": "U+1F3C8"
      },
      {
        "emoji": "🏉",
        "name": "rugby football",
        "code": "U+1F3C9"
      },
      {
        "emoji": "🏆",
        "name": "trophy",
        "code": "U+1F3C6"
      },
      {
        "emoji": "🏁",
        "name": "chequered flag",
        "code": "U+1F3C1"
      },
      {
        "emoji": "⛳",
        "name": "flag in hole",
        "code": "U+26F3"
      },
      {
        "emoji": "🎿",
        "name": "ski and ski boot",
        "code": "U+1F3BF"
      },
      {
        "emoji": "🏂",
        "name": "snowboarder",
        "code": "U+1F3C2"
      },
      {
        "emoji": "🏃",
        "name": "runner",
        "code": "U+1F3C3"
      },
      {
        "emoji": "🏄",
        "name": "surfer",
        "code": "U+1F3C4"
      },
      {
        "emoji": "🏊",
        "name": "swimmer",
        "code": "U+1F3CA"
      },
      {
        "emoji": "🏇",
        "name": "horse racer",
        "code": "U+1F3C7"
      },
      {
        "emoji": "🚴",
        "name": "bicyclist",
        "code": "U+1F6B4"
      },
      {
        "emoji": "🚣",
        "name": "rowboat",
        "code": "U+1F6A3"
      },
      {
        "emoji": "🎁",
        "name": "wrapped present",
        "code": "U+1F381"
      },
      {
        "emoji": "🎂",
        "name": "birthday cake",
        "code": "U+1F382"
      },
      {
        "emoji": "🎄",
        "name": "christmas tree",
        "code": "U+1F384"
      },
      {
        "emoji": "🎆",
        "name": "fireworks",
        "code": "U+1F386"
      },
      {
        "emoji": "🎈",
        "name": "balloon",
        "code": "U+1F388"
      },
      {
        "emoji": "🎉",
        "name": "party popper",
        "code": "U+1F389"
      },
      {
        "emoji": "🎍",
        "name": "pine decoration",
        "code": "U+1F38D"
      },
      {
        "emoji": "🎇",
        "name": "firework sparkler",
        "code": "U+1F387"
      },
      {
        "emoji": "🎃",
        "name": "jack-o-lantern",
        "code": "U+1F383"
      },
      {
        "emoji": "🎊",
        "name": "confetti ball",
        "code": "U+1F38A"
      },
      {
        "emoji": "⛺",
        "name": "tent",
        "code": "U+26FA"
      },
      {
        "emoji": "🎠",
        "name": "carousel horse",
        "code": "U+1F3A0"
      },
      {
        "emoji": "🎡",
        "name": "ferris wheel",
        "code": "U+1F3A1"
      },
      {
        "emoji": "🎢",
        "name": "roller coaster",
        "code": "U+1F3A2"
      },
      {
        "emoji": "🎣",
        "name": "fishing pole and fish",
        "code": "U+1F3A3"
      },
      {
        "emoji": "🎤",
        "name": "microphone",
        "code": "U+1F3A4"
      },
      {
        "emoji": "🎥",
        "name": "movie camera",
        "code": "U+1F3A5"
      },
      {
        "emoji": "📷",
        "name": "camera",
        "code": "U+1F4F7"
      },
      {
        "emoji": "📹",
        "name": "video camera",
        "code": "U+1F4F9"
      },
      {
        "emoji": "🎧",
        "name": "headphone",
        "code": "U+1F3A7"
      },
      {
        "emoji": "🎨",
        "name": "artist palette",
        "code": "U+1F3A8"
      },
      {
        "emoji": "🎩",
        "name": "top hat",
        "code": "U+1F3A9"
      },
      {
        "emoji": "🎪",
        "name": "circus tent",
        "code": "U+1F3AA"
      },
      {
        "emoji": "🎫",
        "name": "ticket",
        "code": "U+1F3AB"
      },
      {
        "emoji": "🎬",
        "name": "clapper board",
        "code": "U+1F3AC"
      },
      {
        "emoji": "🎭",
        "name": "performing arts",
        "code": "U+1F3AD"
      },
      {
        "emoji": "🎮",
        "name": "video game",
        "code": "U+1F3AE"
      },
      {
        "emoji": "🀄",
        "name": "mahjong tile red dragon",
        "code": "U+1F004"
      },
      {
        "emoji": "🎯",
        "name": "direct hit",
        "code": "U+1F3AF"
      },
      {
        "emoji": "🎰",
        "name": "slot machine",
        "code": "U+1F3B0"
      },
      {
        "emoji": "🎱",
        "name": "billiards",
        "code": "U+1F3B1"
      },
      {
        "emoji": "🎲",
        "name": "game die",
        "code": "U+1F3B2"
      },
      {
        "emoji": "🎳",
        "name": "bowling",
        "code": "U+1F3B3"
      },
      {
        "emoji": "🃏",
        "name": "playing card black joker",
        "code": "U+1F0CF"
      },
      {
        "emoji": "🎵",
        "name": "musical note",
        "code": "U+1F3B5"
      },
      {
        "emoji": "🎶",
        "name": "multiple musical notes",
        "code": "U+1F3B6"
      },
      {
        "emoji": "🎷",
        "name": "saxophone",
        "code": "U+1F3B7"
      },
      {
        "emoji": "🎸",
        "name": "guitar",
        "code": "U+1F3B8"
      },
      {
        "emoji": "🎹",
        "name": "musical keyboard",
        "code": "U+1F3B9"
      },
      {
        "emoji": "🎺",
        "name": "trumpet",
        "code": "U+1F3BA"
      },
      {
        "emoji": "🎻",
        "name": "violin",
        "code": "U+1F3BB"
      },
      {
        "emoji": "🚬",
        "name": "smoking symbol",
        "code": "U+1F6AC"
      },
      {
        "emoji": "🔔",
        "name": "bell",
        "code": "U+1F514"
      },
      {
        "emoji": "🔕",
        "name": "bell with cancellation stroke",
        "code": "U+1F515"
      },
      {
        "emoji": "🔉",
        "name": "speaker with one sound wave",
        "code": "U+1F509"
      },
      {
        "emoji": "🔇",
        "name": "speaker with cancellation stroke",
        "code": "U+1F507"
      }
    ]
  },
  {
    "type": "food",
    "title": "食物",
    "info": [
      {
        "emoji": "🍋",
        "name": "lemon",
        "code": "U+1F34B"
      },
      {
        "emoji": "🍌",
        "name": "banana",
        "code": "U+1F34C"
      },
      {
        "emoji": "🍒",
        "name": "cherries",
        "code": "U+1F352"
      },
      {
        "emoji": "🍐",
        "name": "pear",
        "code": "U+1F350"
      },
      {
        "emoji": "🍎",
        "name": "red apple",
        "code": "U+1F34E"
      },
      {
        "emoji": "🍊",
        "name": "tangerine",
        "code": "U+1F34A"
      },
      {
        "emoji": "🍓",
        "name": "strawberry",
        "code": "U+1F353"
      },
      {
        "emoji": "🍉",
        "name": "watermelon",
        "code": "U+1F349"
      },
      {
        "emoji": "🍅",
        "name": "tomato",
        "code": "U+1F345"
      },
      {
        "emoji": "🍆",
        "name": "aubergine",
        "code": "U+1F346"
      },
      {
        "emoji": "🍈",
        "name": "melon",
        "code": "U+1F348"
      },
      {
        "emoji": "🍍",
        "name": "pineapple",
        "code": "U+1F34D"
      },
      {
        "emoji": "🍇",
        "name": "grapes",
        "code": "U+1F347"
      },
      {
        "emoji": "🍑",
        "name": "peach",
        "code": "U+1F351\""
      },
      {
        "emoji": "🍏",
        "name": "green apple",
        "code": "U+1F34F"
      },
      {
        "emoji": "🌽",
        "name": "ear of maize",
        "code": "U+1F33D"
      },
      {
        "emoji": "🍄",
        "name": "mushroom",
        "code": "U+1F344"
      },
      {
        "emoji": "🌰",
        "name": "chestnut",
        "code": "U+1F330"
      },
      {
        "emoji": "🍔",
        "name": "hamburger",
        "code": "U+1F354"
      },
      {
        "emoji": "🍙",
        "name": "rice ball",
        "code": "U+1F359"
      },
      {
        "emoji": "🍰",
        "name": "shortcake",
        "code": "U+1F370"
      },
      {
        "emoji": "🍜",
        "name": "steaming bowl",
        "code": "U+1F35C"
      },
      {
        "emoji": "🍞",
        "name": "bread",
        "code": "U+1F35E"
      },
      {
        "emoji": "🍳",
        "name": "cooking",
        "code": "U+1F373"
      },
      {
        "emoji": "🍟",
        "name": "french fries",
        "code": "U+1F35F"
      },
      {
        "emoji": "🍡",
        "name": "dango",
        "code": "U+1F361"
      },
      {
        "emoji": "🍘",
        "name": "rice cracker",
        "code": "U+1F358"
      },
      {
        "emoji": "🍚",
        "name": "cooked rice",
        "code": "U+1F35A"
      },
      {
        "emoji": "🍝",
        "name": "spaghetti",
        "code": "U+1F35D"
      },
      {
        "emoji": "🍛",
        "name": "curry and rice",
        "code": "U+1F35B"
      },
      {
        "emoji": "🍢",
        "name": "oden",
        "code": "U+1F362"
      },
      {
        "emoji": "🍣",
        "name": "sushi",
        "code": "U+1F363"
      },
      {
        "emoji": "🍱",
        "name": "bento box",
        "code": "U+1F371"
      },
      {
        "emoji": "🍲",
        "name": "pot of food",
        "code": "U+1F372"
      },
      {
        "emoji": "🍧",
        "name": "shaved ice",
        "code": "U+1F367"
      },
      {
        "emoji": "🍖",
        "name": "meat on bone",
        "code": "U+1F356"
      },
      {
        "emoji": "🍥",
        "name": "fish cake with swirl design",
        "code": "U+1F365"
      },
      {
        "emoji": "🍠",
        "name": "roasted sweet potato",
        "code": "U+1F360"
      },
      {
        "emoji": "🍕",
        "name": "slice of pizza",
        "code": "U+1F355"
      },
      {
        "emoji": "🍗",
        "name": "poultry leg",
        "code": "U+1F357"
      },
      {
        "emoji": "🍨",
        "name": "ice cream",
        "code": "U+1F368"
      },
      {
        "emoji": "🍩",
        "name": "doughnut",
        "code": "U+1F369"
      },
      {
        "emoji": "🍪",
        "name": "cookie",
        "code": "U+1F36A"
      },
      {
        "emoji": "🍬",
        "name": "candy",
        "code": "U+1F36C"
      },
      {
        "emoji": "🍭",
        "name": "lollipop",
        "code": "U+1F36D"
      },
      {
        "emoji": "🍮",
        "name": "custard",
        "code": "U+1F36E"
      },
      {
        "emoji": "🍯",
        "name": "honey pot",
        "code": "U+1F36F"
      },
      {
        "emoji": "🍤",
        "name": "fried shrimp",
        "code": "U+1F364"
      },
      {
        "emoji": "🍸",
        "name": "cocktail glass",
        "code": "U+1F378"
      },
      {
        "emoji": "🍺",
        "name": "beer mug",
        "code": "U+1F37A"
      },
      {
        "emoji": "🍵",
        "name": "teacup without handle",
        "code": "U+1F375"
      },
      {
        "emoji": "🍶",
        "name": "sake bottle and cup",
        "code": "U+1F376"
      },
      {
        "emoji": "🍻",
        "name": "clinking beer mugs",
        "code": "U+1F37B"
      },
      {
        "emoji": "🍹",
        "name": "tropical drink",
        "code": "U+1F379"
      }
    ]
  },
  {
    "type": "animal",
    "title": "动物",
    "info": [
      {
        "emoji": "😺",
        "name": "smiling cat face with open mouth",
        "code": "U+1F63A"
      },
      {
        "emoji": "😸",
        "name": "grinning cat face with smiling eyes",
        "code": "U+1F638"
      },
      {
        "emoji": "😹",
        "name": "cat face with tears of joy",
        "code": "U+1F639"
      },
      {
        "emoji": "😽",
        "name": "kissing cat face with closed eyes",
        "code": "U+1F63D"
      },
      {
        "emoji": "😻",
        "name": "smiling cat face with heart-shaped eyes",
        "code": "U+1F63B"
      },
      {
        "emoji": "😿",
        "name": "crying cat face",
        "code": "U+1F63F"
      },
      {
        "emoji": "😾",
        "name": "pouting cat face",
        "code": "U+1F63E"
      },
      {
        "emoji": "😼",
        "name": "cat face with wry smile",
        "code": "U+1F63C"
      },
      {
        "emoji": "🙀",
        "name": "weary cat face",
        "code": "U+1F640"
      },
      {
        "emoji": "🐵",
        "name": "monkey face",
        "code": "U+1F435"
      },
      {
        "emoji": "🙈",
        "name": "see-no-evil monkey",
        "code": "U+1F648"
      },
      {
        "emoji": "🙊",
        "name": "speak-no-evil monkey",
        "code": "U+1F64A"
      },
      {
        "emoji": "🙉",
        "name": "hear-no-evil monkey",
        "code": "U+1F649"
      },
      {
        "emoji": "🐶",
        "name": "dog face",
        "code": "U+1F436"
      },
      {
        "emoji": "🐷",
        "name": "pig face",
        "code": "U+1F437"
      },
      {
        "emoji": "🐻",
        "name": "bear face",
        "code": "U+1F43B"
      },
      {
        "emoji": "🐹",
        "name": "hamster face",
        "code": "U+1F439"
      },
      {
        "emoji": "🐭",
        "name": "mouse face",
        "code": "U+1F42D"
      },
      {
        "emoji": "🐯",
        "name": "tiger face",
        "code": "U+1F42F"
      },
      {
        "emoji": "🐱",
        "name": "cat face",
        "code": "U+1F431"
      },
      {
        "emoji": "🐺",
        "name": "wolf face",
        "code": "U+1F43A"
      },
      {
        "emoji": "🐮",
        "name": "cow face",
        "code": "U+1F42E"
      },
      {
        "emoji": "🐰",
        "name": "rabbit face",
        "code": "U+1F430"
      },
      {
        "emoji": "🐸",
        "name": "frog face",
        "code": "U+1F438"
      },
      {
        "emoji": "🐾",
        "name": "paw prints",
        "code": "U+1F43E"
      },
      {
        "emoji": "🐲",
        "name": "dragon face",
        "code": "U+1F432"
      },
      {
        "emoji": "🐼",
        "name": "panda face",
        "code": "U+1F43C"
      },
      {
        "emoji": "🐽",
        "name": "pig nose",
        "code": "U+1F43D"
      },
      {
        "emoji": "🐤",
        "name": "baby chick",
        "code": "U+1F424"
      },
      {
        "emoji": "🐦",
        "name": "bird",
        "code": "U+1F426"
      },
      {
        "emoji": "🐧",
        "name": "penguin",
        "code": "U+1F427"
      },
      {
        "emoji": "🐔",
        "name": "chicken",
        "code": "U+1F414"
      },
      {
        "emoji": "🐨",
        "name": "koala",
        "code": "U+1F428"
      },
      {
        "emoji": "🐙",
        "name": "octopus",
        "code": "U+1F419"
      },
      {
        "emoji": "🐑",
        "name": "sheep",
        "code": "U+1F411"
      },
      {
        "emoji": "🐏",
        "name": "ram",
        "code": "U+1F40F"
      },
      {
        "emoji": "🐐",
        "name": "goat",
        "code": "U+1F410"
      },
      {
        "emoji": "🐓",
        "name": "rooster",
        "code": "U+1F413"
      },
      {
        "emoji": "🐕",
        "name": "dog",
        "code": "U+1F415"
      },
      {
        "emoji": "🐖",
        "name": "pig",
        "code": "U+1F416"
      },
      {
        "emoji": "🐪",
        "name": "dromedary camel",
        "code": "U+1F42A"
      },
      {
        "emoji": "🐴",
        "name": "horse face",
        "code": "U+1F434"
      },
      {
        "emoji": "🐌",
        "name": "snail",
        "code": "U+1F40C"
      },
      {
        "emoji": "🐍",
        "name": "snake",
        "code": "U+1F40D"
      },
      {
        "emoji": "🐎",
        "name": "horse",
        "code": "U+1F40E"
      },
      {
        "emoji": "🐊",
        "name": "crocodile",
        "code": "U+1F40A"
      },
      {
        "emoji": "🐋",
        "name": "whale",
        "code": "U+1F40B"
      },
      {
        "emoji": "🐉",
        "name": "dragon",
        "code": "U+1F409"
      },
      {
        "emoji": "🐈",
        "name": "cat",
        "code": "U+1F408"
      },
      {
        "emoji": "🐇",
        "name": "rabbit",
        "code": "U+1F407"
      },
      {
        "emoji": "🐆",
        "name": "leopard",
        "code": "U+1F406"
      },
      {
        "emoji": "🐅",
        "name": "tiger",
        "code": "U+1F405"
      },
      {
        "emoji": "🐄",
        "name": "cow",
        "code": "U+1F404"
      },
      {
        "emoji": "🐃",
        "name": "water buffalo",
        "code": "U+1F403"
      },
      {
        "emoji": "🐂",
        "name": "ox",
        "code": "U+1F402"
      },
      {
        "emoji": "🐁",
        "name": "mouse",
        "code": "U+1F401"
      },
      {
        "emoji": "🐀",
        "name": "rat",
        "code": "U+1F400"
      },
      {
        "emoji": "🐗",
        "name": "boar",
        "code": "U+1F417"
      },
      {
        "emoji": "🐫",
        "name": "bactrian camel",
        "code": "U+1F42B"
      },
      {
        "emoji": "🐘",
        "name": "elephant",
        "code": "U+1F418"
      },
      {
        "emoji": "🐒",
        "name": "monkey",
        "code": "U+1F412"
      },
      {
        "emoji": "🐛",
        "name": "bug",
        "code": "U+1F41B"
      },
      {
        "emoji": "🐜",
        "name": "ant",
        "code": "U+1F41C"
      },
      {
        "emoji": "🐝",
        "name": "honeybee",
        "code": "U+1F41D"
      },
      {
        "emoji": "🐞",
        "name": "lady beetle",
        "code": "U+1F41E"
      },
      {
        "emoji": "🐠",
        "name": "tropical fish",
        "code": "U+1F420"
      },
      {
        "emoji": "🐡",
        "name": "blowfish",
        "code": "U+1F421"
      },
      {
        "emoji": "🐢",
        "name": "turtle",
        "code": "U+1F422"
      },
      {
        "emoji": "🐥",
        "name": "front-facing baby chick",
        "code": "U+1F425"
      },
      {
        "emoji": "🐣",
        "name": "hatching chick",
        "code": "U+1F423"
      },
      {
        "emoji": "🐩",
        "name": "poodle",
        "code": "U+1F429"
      },
      {
        "emoji": "🐟",
        "name": "fish",
        "code": "U+1F41F"
      },
      {
        "emoji": "🐬",
        "name": "dolphin",
        "code": "U+1F42C"
      },
      {
        "emoji": "🐳",
        "name": "spouting whale",
        "code": "U+1F433"
      }
    ]
  },
  {
    "type": "facilities",
    "title": "设施",
    "info": [
      {
        "emoji": "🏠",
        "name": "house building",
        "code": "U+1F3E0"
      },
      {
        "emoji": "🏡",
        "name": "house with garden",
        "code": "U+1F3E1"
      },
      {
        "emoji": "🏢",
        "name": "office building",
        "code": "U+1F3E2"
      },
      {
        "emoji": "🏣",
        "name": "japanese post office",
        "code": "U+1F3E3"
      },
      {
        "emoji": "🏤",
        "name": "european post office",
        "code": "U+1F3E4"
      },
      {
        "emoji": "🏥",
        "name": "hospital",
        "code": "U+1F3E5"
      },
      {
        "emoji": "🏦",
        "name": "bank",
        "code": "U+1F3E6"
      },
      {
        "emoji": "🏧",
        "name": "automated teller machine",
        "code": "U+1F3E7"
      },
      {
        "emoji": "🏨",
        "name": "hotel",
        "code": "U+1F3E8"
      },
      {
        "emoji": "🏩",
        "name": "love hotel",
        "code": "U+1F3E9"
      },
      {
        "emoji": "🏪",
        "name": "convenience store",
        "code": "U+1F3EA"
      },
      {
        "emoji": "💒",
        "name": "wedding",
        "code": "U+1F492"
      },
      {
        "emoji": "🏫",
        "name": "school",
        "code": "U+1F3EB"
      },
      {
        "emoji": "⛪",
        "name": "church",
        "code": "U+26EA"
      },
      {
        "emoji": "⛲",
        "name": "fountain",
        "code": "U+26F2"
      },
      {
        "emoji": "🏬",
        "name": "department store",
        "code": "U+1F3EC"
      },
      {
        "emoji": "🏯",
        "name": "japanese castle",
        "code": "U+1F3EF"
      },
      {
        "emoji": "🏰",
        "name": "european castle",
        "code": "U+1F3F0"
      },
      {
        "emoji": "🏭",
        "name": "factory",
        "code": "U+1F3ED"
      },
      {
        "emoji": "🚃",
        "name": "railway car",
        "code": "U+1F683"
      },
      {
        "emoji": "🚄",
        "name": "high-speed train",
        "code": "U+1F684"
      },
      {
        "emoji": "🚅",
        "name": "high-speed train with bullet nose",
        "code": "U+1F685"
      },
      {
        "emoji": "🚗",
        "name": "automobile",
        "code": "U+1F697"
      },
      {
        "emoji": "🚙",
        "name": "recreational vehicle",
        "code": "U+1F699"
      },
      {
        "emoji": "🚌",
        "name": "bus",
        "code": "U+1F68C"
      },
      {
        "emoji": "🚲",
        "name": "bicycle",
        "code": "U+1F6B2"
      },
      {
        "emoji": "🚁",
        "name": "helicopter",
        "code": "U+1F681"
      },
      {
        "emoji": "🚂",
        "name": "steam locomotive",
        "code": "U+1F682"
      },
      {
        "emoji": "🚈",
        "name": "light rail",
        "code": "U+1F688"
      },
      {
        "emoji": "🚎",
        "name": "trolleybus",
        "code": "U+1F68E"
      },
      {
        "emoji": "🚐",
        "name": "minibus",
        "code": "U+1F690"
      },
      {
        "emoji": "🚢",
        "name": "ship",
        "code": "U+1F6A2"
      },
      {
        "emoji": "⛵",
        "name": "sailboat",
        "code": "U+26F5"
      },
      {
        "emoji": "🚛",
        "name": "articulated lorry",
        "code": "U+1F69B"
      },
      {
        "emoji": "🚜",
        "name": "tractor",
        "code": "U+1F69C"
      },
      {
        "emoji": "🚝",
        "name": "monorail",
        "code": "U+1F69D"
      },
      {
        "emoji": "🚞",
        "name": "mountain railway",
        "code": "U+1F69E"
      },
      {
        "emoji": "🚟",
        "name": "suspension railway",
        "code": "U+1F69F"
      },
      {
        "emoji": "🚠",
        "name": "mountain cableway",
        "code": "U+1F6A0"
      },
      {
        "emoji": "🚀",
        "name": "rocket",
        "code": "U+1F680"
      },
      {
        "emoji": "🚤",
        "name": "speedboat",
        "code": "U+1F6A4"
      },
      {
        "emoji": "🚕",
        "name": "taxi",
        "code": "U+1F695"
      },
      {
        "emoji": "🚚",
        "name": "delivery truck",
        "code": "U+1F69A"
      },
      {
        "emoji": "🚒",
        "name": "fire engine",
        "code": "U+1F692"
      },
      {
        "emoji": "🚑",
        "name": "ambulance",
        "code": "U+1F691"
      },
      {
        "emoji": "🚓",
        "name": "police car",
        "code": "U+1F693"
      },
      {
        "emoji": "🚍",
        "name": "oncoming bus",
        "code": "U+1F68D"
      },
      {
        "emoji": "🚔",
        "name": "oncoming police car",
        "code": "U+1F694oncoming police car"
      },
      {
        "emoji": "🚖",
        "name": "oncoming taxi",
        "code": "U+1F696"
      },
      {
        "emoji": "🚘",
        "name": "oncoming automobile",
        "code": "U+1F698"
      },
      {
        "emoji": "🚆",
        "name": "train",
        "code": "U+1F686"
      },
      {
        "emoji": "🚊",
        "name": "tram",
        "code": "U+1F68A"
      },
      {
        "emoji": "🚉",
        "name": "station",
        "code": "U+1F689"
      },
      {
        "emoji": "🚇",
        "name": "metro",
        "code": "U+1F687"
      },
      {
        "emoji": "⛽",
        "name": "fuel pump",
        "code": "U+26FD"
      },
      {
        "emoji": "🅿",
        "name": "negative squared latin capital letter p",
        "code": "U+1F17F"
      },
      {
        "emoji": "🚥",
        "name": "horizontal traffic light",
        "code": "U+1F6A5"
      },
      {
        "emoji": "🚧",
        "name": "construction sign",
        "code": "U+1F6A7"
      },
      {
        "emoji": "🚨",
        "name": "police cars revolving light",
        "code": "U+1F6A8"
      },
      {
        "emoji": "✈️",
        "name": "airplane",
        "code": "U+2708"
      }
    ]
  }
]
